export const POST_DONATORS_REQUEST='POST_DONATORS_REQUEST'
export const POST_DONATORS_SUCCESS='POST_DONATORS_SUCCESS'
export const POST_DONATORS_FAILURE='POST_DONATORS_FAILURE'